import { h } from 'preact'; /** @jsx h */

import './FactsItem.scss';

const FactsItem = ({ children }) => {
    return <li className={`facts-item-li`} dangerouslySetInnerHTML={{ __html: children }} />;
};

export default FactsItem;
